// Same Persian labels used by the real Calendar week view (Week.js) - kept in
// sync so a challenge meal reads identically wherever it shows up.
const mealTypeLabels = {
  breakfast: "صبحانه",
  snack1: "میان‌وعده صبح",
  lunch: "نهار",
  snack2: "میان‌وعده عصر",
  dinner: "شام",
  snack3: "میان‌وعده شب",
};

export default mealTypeLabels;
